// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__3Hnu7","table_caption":"table_table_caption__13EWe"};